define(function(require) {
    const TokenTemplate = require('./Token.template.html');
    const BaseFormView = require('app/BaseForm.view');
    const _ = require('underscore');
    const Backbone = require('backbone');
    const CC = require('CC');
    const TokenModel = require('models/user/Tokens.model');

    const TokenView = BaseFormView.extend({
        template: _.template(TokenTemplate),

        defaults: function() {
            return {
                model: new TokenModel()
            };
        },

        events: {},

        form: [
            {
                name: 'description',
                label: 'Description',
                tooltip: 'The purpose of the key',
                type: 'string'
            }
        ],

        initialize: function(options) {
            _.extend(this, this.defaults(), options);
            Backbone.Validation.bind(this);
        },

        render: function() {
            const clientRoleSet = CC.SessionData.userInfo.get('clientRoleSet');
            const numClients = clientRoleSet.length;
            let clientName = undefined;
            let roleName = undefined;
            let numRoles = 1;
            if (numClients > 1) {
                const roleHash = {};
                _.each(clientRoleSet, roleObj => {
                    roleHash[roleObj.role.displayName] = true;
                });
                const roles = Object.keys(roleHash);
                numRoles = roles.length;
                if (numRoles == 1) {
                    roleName = roles[0];
                }
            } else {
                clientName = clientRoleSet[0].client.name;
                roleName = clientRoleSet[0].role.displayName;
            }
            const viewOptions = {
                clientName: clientName,
                roleName: roleName,
                numClients: numClients,
                numRoles: numRoles
            };

            this.$el.html(this.template(viewOptions));
            this.renderForm('#token-form-holder');
            this.$('#description').trigger('focus');

            return this;
        },

        save: function() {
            this.model.validate();
            if (this.model.isValid()) {
                return this.model.save();
            }
            return null;
        }
    });

    return TokenView;
});
